import ListMetaRow from "./ListMetaRow";
import { FONT_SIZES, GRADIENTS } from "../../theme";

export default function TwoColList({ date, tablet, gradients, showIcons, displayDates, image, title }) {
    return (
        <>
            {/* 2 Column List */}
            <div className="tile-image" style={{ position: 'relative', marginBottom: tablet ? "2rem" : "0" }}>
                <img src={image ? image : 'plus.png'} style={{ width: "100%", objectFit: "cover", borderRadius: "16px", height: tablet ? "36rem" : "24rem" }} alt="" />
                <div style={{ position: "absolute", bottom: "2rem", left: "2rem", right: "2rem", zIndex: 20 }}>
                    <p style={{ fontSize: FONT_SIZES.listTitle, margin: 0, zIndex: 20 }}>{title}</p>
                    <ListMetaRow showIcons={showIcons} displayDates={displayDates} date={date} />
                </div>
                <div className='gradient' style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0, background: GRADIENTS.imageOverlay, zIndex: 2, opacity: gradients ? "90%" : "0", borderRadius: "16px" }}>&nbsp;</div>
            </div>
            {/* 2 Column List */}
        </>
    )
}